module.exports = __webpack_public_path__ + "img/1.ca11ad5f.jpg";